module.exports = __webpack_public_path__ + "img/ltkfitness-1x.4ff5357.jpg";